import { render, staticRenderFns } from "./PaidSuccess.vue?vue&type=template&id=3ea12866&scoped=true&"
import script from "./PaidSuccess.vue?vue&type=script&lang=tsx&"
export * from "./PaidSuccess.vue?vue&type=script&lang=tsx&"
import style0 from "./PaidSuccess.vue?vue&type=style&index=0&id=3ea12866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea12866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea12866')) {
      api.createRecord('3ea12866', component.options)
    } else {
      api.reload('3ea12866', component.options)
    }
    module.hot.accept("./PaidSuccess.vue?vue&type=template&id=3ea12866&scoped=true&", function () {
      api.rerender('3ea12866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PaidSuccess.vue"
export default component.exports